import { CSSProperties } from "react";

export const XFreighterSvg = ({
  width,
  style,
}: {
  style?: CSSProperties;
  width: number;
  color?: string;
}) => {
  return (
    <svg
      width={width}
      height={(width * 630) / 608}
      viewBox="0 0 608 630"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="M608 135.905L304 0V630H441.912L608 135.905Z" fill="#CECECE" />
      <path d="M0 135.905L304 0V630H166.088L0 135.905Z" fill="#CECECE" />
      <path
        d="M349.5 235.5C340.412 93.0271 329.899 56.8514 304 50V574.5H332.5L349.5 523L435.5 560.5V523L358.5 436L364.5 403L511 436L536 427L373 294L349.5 235.5Z"
        fill="#010E3E"
        stroke="black"
      />
      <path
        d="M258.5 235.5C267.588 93.0271 278.101 56.8514 304 50V574.5H275.5L258.5 523L172.5 560.5V523L249.5 436L243.5 403L97 436L72 427L235 294L258.5 235.5Z"
        fill="#010E3E"
        stroke="black"
      />
    </svg>
  );
};
